export default __webpack_public_path__ + "static/media/diamond.28c0ffc42993571a419ad62ebf6b86a6.svg";